import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Egg } from "lucide-react";
import { api, errText } from "../../lib/api";

const OPTIONS = [
  { id: "breeders", label: "Verified breeders only", hint: "Other members are asked to apply for the Verified Breeder badge first" },
  { id: "members", label: "Every signed-in member", hint: "Anyone with an account can post litters and run a waitlist" },
];

export function LitterRulesToggle() {
  const [who, setWho] = useState(null);
  useEffect(() => { api.get("/admin/site/litter-rules").then((r) => setWho(r.data.who)).catch(() => {}); }, []);
  const pick = async (v) => {
    if (v === who) return;
    try {
      const { data } = await api.put("/admin/site/litter-rules", { who: v });
      setWho(data.who);
      toast.success(data.who === "members" ? "Every member can now post litters" : "Only verified breeders can post litters now");
    } catch (e) { toast.error(errText(e)); }
  };
  if (who === null) return null;
  return (
    <div className="bg-white rounded-2xl border border-slate-200/80 p-5 mb-6" data-testid="litter-rules-card">
      <div className="flex gap-3">
        <span className="h-10 w-10 shrink-0 rounded-xl bg-[#FFF4F0] flex items-center justify-center"><Egg size={18} className="text-[#F5551E]" /></span>
        <div>
          <h3 className="font-display font-bold text-[#12234A]">Who can post litters &amp; clutches</h3>
          <p className="text-xs text-slate-500 mt-0.5">Applies straight away. Existing litters from members stay hidden while this is set to verified breeders only.</p>
        </div>
      </div>
      <div className="grid sm:grid-cols-2 gap-3 mt-4">
        {OPTIONS.map((o) => (
          <button key={o.id} onClick={() => pick(o.id)} data-testid={`litter-rules-${o.id}`} aria-pressed={who === o.id}
            className={`text-left rounded-xl border-2 p-3 transition-colors ${who === o.id ? "border-[#F5551E] bg-[#FFF4F0]" : "border-slate-200 hover:border-slate-300"}`}>
            <p className="font-semibold text-sm text-[#12234A]">{o.label}</p>
            <p className="text-xs text-slate-500 mt-0.5">{o.hint}</p>
          </button>
        ))}
      </div>
    </div>
  );
}
